import * as React from "preact";
import { FunctionComponent } from "preact";

import Cookies from "js-cookie";

import { IResult } from "../Result";

export interface ICompleteOnlineProps {
  item: IResult;
}

const CompleteOnline: FunctionComponent<ICompleteOnlineProps> = ({ item }) => {
  const { completeOnlineOpenInSameTab, completeOnlineUrls } = item;

  const roleId = Cookies.get("Role");
  const target = completeOnlineOpenInSameTab ? "_self" : "_blank";
  const roleLink = completeOnlineUrls?.filter((x) => x.roleId == roleId);
  if (!roleLink) {
    return null;
  }
  return (
    roleLink[0] && (
      <a
        target={target}
        href={roleLink[0].completeOnlineUrl}
      >
        <span className="tag tag--with-bg tag--space-top">{item.completeOnlineText}</span>
      </a>
    )
  );
};

export default CompleteOnline;
